import { mapActions } from "vuex";
import * as DESTINIES_ACTIONS from "../../../../store/destinies/action-types";
import prependCustomIcons from "../../../../utils/mixins/prependCustomIcons";
import replaceArrows from "../../../../utils/mixins/replaceArrows";

export default {
  mixins: [prependCustomIcons, replaceArrows],
  data: () => ({
    activeTab: 0,
    searchType: 1,
    tab: null,
    showDialog: false,
    items: [
      {
        tab:
          'shared.single_day',
        disabled: false,
        icon: "ODAY",
        content: "HOLA1"
      },
      {
        tab: 'shared.more_one_day',
        disabled: false,
        icon: "MDAYS",
        content: "HOLA2"
      }
    ]
  }),
  watch: {
    tab: function (val) {
      this.activeTab = val;
    }
  },
  methods: {
    ...mapActions({
      fetchPlaces: DESTINIES_ACTIONS.FETCH_PLACES
    }),
    handleTabChange(event) {
      this.activeTab = event;
      if (event === 1) {
        this.searchType = 2;
        this.$nextTick(() => {
          // this.prependCustomIcons();
          // this.replaceArrows();
        });
      } else {
        this.searchType = 1;
      }
    },
    handleSearchTypeButton(event) {
      this.searchType =
        event.currentTarget.getAttribute("id") === "when" ? 0 : 1;
      this.$nextTick(() => {
        this.prependCustomIcons();
        this.replaceArrows();
      });
    }
  }
};
